// src/services/latestPublicationService.js

import axios from "axios";

/**
 * ✅ Instance Axios dédiée uniquement aux publications récentes
 */
const latestApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

/**
 *  Intercepteur (optionnel mais pro)
 */
latestApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Erreur API Latest Publications:", error?.response || error.message);
    return Promise.reject(error);
  }
);

/**
 * ✅ Récupérer les 5 dernières publications
 */
export const getLatestPublications = async () => {
  try {
    const response = await latestApi.get("latest");

    // 🔒 Sécurisation
    if (Array.isArray(response.data?.data)) {
      return response.data.data;
    }

    return [];
  } catch (error) {
    return [];
  }
};

/**
 * 🔥 (OPTIONNEL) Récupérer avec limite dynamique
 */
export const getLatestPublicationsWithLimit = async (limit = 5) => {
  try {
    const response = await latestApi.get(`latest?limit=${limit}`);

    return Array.isArray(response.data?.data)
      ? response.data.data
      : [];
  } catch (error) {
    return [];
  }
};